import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  alert: {
    borderRadius: 0,
  },
}))

export default useStyles
